import { z } from 'zod';
import {
    type NodeSocketCfg,
    baseNodeCfgSchema,
} from './base-node';

export const staticWorkOrderStatusEnumSchema = z.enum([
    'staged',
    'released',
    'completed',
    'manually_completed',
]);

export const workOrderSetStatusCfgSchema = baseNodeCfgSchema.extend({
    controlValues: z.object({
        status: staticWorkOrderStatusEnumSchema,
    }),
    kind: z.literal('workOrderSetStatus'),
});
interface WorkOrderSetStatusCfgSchema extends z.infer<typeof workOrderSetStatusCfgSchema> {}

export const workOrderSetStatusSocketCfg = {
    controlSockets: {
        outputs: () => ({ next: 'event' }),
        inputs: () => ({ trigger: 'event' }),
    },
    dataSockets: {
        outputs: () => ({}),
        inputs: () => ({
            statusNote: 'string',
            workOrderId: 'string',
        }),
    },
} satisfies NodeSocketCfg<WorkOrderSetStatusCfgSchema>;
